module.exports = __webpack_public_path__ + "static/media/d.0d6a86e7.png";